import React from 'react'
import Info from '@material-ui/icons/Info'
import Warning from '@material-ui/icons/Warning'
import InfoPanelStyle from '../styles/InfoPanelStyle'

class InfoPanel extends React.Component {
  state = {
    isExpanded: false,
  }

  handleClick = () => {
    if (this.props.canExpand)
      this.setState({ isExpanded: !this.state.isExpanded })
  }

  render() {
    const {
      canExpand,
      exptandContent,
      rolledContent,
      warningColor,
      warningIcon,
    } = this.props
    return (
      <InfoPanelStyle warningColor={warningColor} className="info-on-print">
        <div className="info">
          <div className="info-icon">
            {warningIcon ? <Warning /> : <Info />}
          </div>
          <div className="info-text">
            {this.state.isExpanded ? exptandContent : rolledContent}
          </div>
          <div className="info-more">
            {canExpand ? (
              <span onClick={this.handleClick}>
                {this.state.isExpanded ? 'MNIEJ' : 'WIĘCEJ'}
              </span>
            ) : null}
          </div>
        </div>
      </InfoPanelStyle>
    )
  }
}

export default InfoPanel
